import { render, staticRenderFns } from "./promotional-list.vue?vue&type=template&id=219fe38e&"
import script from "./promotional-list.vue?vue&type=script&lang=js&"
export * from "./promotional-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports